import { EbEtablissement } from "./etablissement";

export class EbCostCenter {

    ebCostCenterNum: number;
    libelle: string;
    etablissement : EbEtablissement;

    constructor()
    {
        this.ebCostCenterNum = null;
        this.libelle = null;
        this.etablissement = null;
    }

    constructorCopy(ebCostCenter:EbCostCenter)
    {
        this.constructor();
        this.ebCostCenterNum = ebCostCenter.ebCostCenterNum;
        this.libelle = ebCostCenter.libelle;
        if(ebCostCenter.etablissement != null)
        {
            ebCostCenter.etablissement.costCenters = null;
            this.etablissement = ebCostCenter.etablissement;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/classes/costCenter.ts